// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Videos-module--wrapper--SLoDQ","top":"Videos-module--top--1APbh","videos":"Videos-module--videos--24ihy","video":"Videos-module--video--mgazu"};